import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { CIF } from "@/constants/testIds";

const FAQS = [
  {
    q: "What is Estimated CIF™?",
    a: "Estimated CIF™ is a Workspace capability inside DeMaxtore that helps importers estimate their total landed cost — combining factory price, estimated freight and estimated insurance — before a Purchase Order is issued. It's not accounting; it's a procurement decision tool.",
  },
  {
    q: "How accurate is the estimate?",
    a: "Estimated CIF™ uses your supplier's quoted FOB, indicative ocean freight from FreightIQ™ (live lane-level rates), and your insurance slab to produce a defensible landed cost. It's directionally accurate for pre-PO purchasing decisions, not a substitute for final commercial invoices.",
  },
  {
    q: "Does freight update automatically?",
    a: "Yes. When FreightIQ™ is connected, your freight estimate refreshes against live indicative rates for the selected destination port and container type. You can also override manually for what-if scenarios.",
  },
  {
    q: "Can I compare different destinations?",
    a: "Absolutely. Spin up multiple CIF scenarios across destination countries, ports and container types side-by-side. The Workspace highlights the lowest cost-per-MT option automatically.",
  },
  {
    q: "Can I estimate multiple containers?",
    a: "Yes. Estimated CIF™ scales from a single 20ft container to a multi-vessel program. Quantity, container mix and freight are all parameterised — the per-MT and total order value update instantly.",
  },
  {
    q: "Can I continue with FreightIQ™?",
    a: "Yes. Once you approve the Estimated CIF™, you can move directly into Purchase Order issuance and book your ocean freight through FreightIQ™ — all without leaving the Workspace.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid={CIF.faq}
      className="relative py-24 lg:py-32 bg-slate-50"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-[10px] tracking-[0.22em] uppercase font-bold text-blue-700">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-600" /> Frequently asked
          </div>
          <h2 className="font-display text-4xl sm:text-5xl font-medium tracking-[-0.025em] leading-[1.05] text-slate-900 mt-4">
            Everything about Estimated CIF™.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 rounded-2xl border border-slate-200 bg-white divide-y divide-slate-100 overflow-hidden">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i + 1}`}
              data-testid={CIF.faqItem(i + 1)}
              className="border-0 px-6"
            >
              <AccordionTrigger
                data-testid={CIF.faqTrigger(i + 1)}
                className="text-left font-display text-[16px] sm:text-[17px] font-medium text-slate-900 py-5 hover:no-underline tracking-tight"
              >
                <span className="flex items-center gap-4">
                  <span className="mono text-[11px] tracking-widest uppercase text-slate-400 font-semibold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {f.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-[14px] text-slate-600 leading-relaxed pb-5 pl-[3.5rem]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
